import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAsoodehDashboardCoins = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={148} height={91} fill='none' {...props}>
    <g opacity={0.5}>
      <path
        fill='url(#asoodehDashboardCoins_svg__a)'
        d='M71.936-1.353 70.858.637s-.311 7.258 8.828 17.706c0 0 6.737 8.289 20.386 5.482 13.653-2.807 27.384-16.947 25.926-37.232 0 0-1.385-9.784-10.985-17.733L71.939-1.354z'
      />
      <path
        fill='url(#asoodehDashboardCoins_svg__b)'
        d='M111.041 10.737c11.871-10.815 15.005-28.197 7.001-38.826-8.004-10.628-24.115-10.478-35.986.336S67.051.444 75.055 11.073c8.004 10.628 24.116 10.478 35.986-.337'
      />
      <path
        stroke='url(#asoodehDashboardCoins_svg__c)'
        strokeMiterlimit={10}
        strokeWidth={0.9}
        d='M111.041 10.737c11.871-10.815 15.005-28.197 7.001-38.826-8.004-10.628-24.115-10.478-35.986.336S67.051.444 75.055 11.073c8.004 10.628 24.116 10.478 35.986-.337Z'
      />
      <path
        fill='#C16F2A'
        d='M107.803 6.44c9.219-8.398 11.652-21.898 5.436-30.153-6.217-8.255-18.73-8.14-27.948.259-9.218 8.398-11.652 21.898-5.435 30.153s18.729 8.139 27.947-.26'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <mask
        id='asoodehDashboardCoins_svg__d'
        width={41}
        height={43}
        x={76}
        y={-30}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill='#fff'
          d='M107.805 6.442c9.219-8.398 11.652-21.898 5.436-30.153-6.217-8.255-18.73-8.14-27.948.259C76.075-15.054 73.641-1.554 79.858 6.7s18.729 8.139 27.947-.26'
        />
      </mask>
      <g mask='url(#asoodehDashboardCoins_svg__d)'>
        <path
          fill='url(#asoodehDashboardCoins_svg__e)'
          d='M108.739 6.918c9.218-8.398 11.652-21.898 5.435-30.153s-18.729-8.139-27.947.26S74.575-1.079 80.79 7.176c6.217 8.256 18.73 8.14 27.948-.259'
        />
      </g>
      <path
        fill='url(#asoodehDashboardCoins_svg__f)'
        d='M107.803 6.44c9.219-8.398 11.652-21.898 5.436-30.153-6.217-8.255-18.73-8.14-27.948.259-9.218 8.398-11.652 21.898-5.435 30.153s18.729 8.139 27.947-.26'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <g
        opacity={0.11}
        style={{
          mixBlendMode: 'overlay',
        }}
      >
        <mask
          id='asoodehDashboardCoins_svg__g'
          width={57}
          height={61}
          x={70}
          y={-36}
          maskUnits='userSpaceOnUse'
          style={{
            maskType: 'luminance',
          }}
        >
          <path
            fill='#fff'
            d='M116.922-29.43c-8.314-9.241-23.523-8.65-34.864 1.68C73.582-20.027 69.56-8.956 70.869.613l-.011.024s-.312 7.257 8.828 17.705c0 0 6.736 8.29 20.386 5.483 13.653-2.808 27.383-16.948 25.925-37.233 0 0-1.202-8.45-9.075-16.022'
          />
        </mask>
        <g fill='#fff' mask='url(#asoodehDashboardCoins_svg__g)'>
          <path d='M100.89-53.704 79.36 26.107l5.226 2.068 21.53-79.811zM112.541-49.528 96.24 32.35l-5.23-2.066zM79.468 12.274l16.3-81.88 5.23 2.066z' />
        </g>
      </g>
    </g>
    <g opacity={0.5}>
      <path
        fill='url(#asoodehDashboardCoins_svg__h)'
        d='m-29.708 21.338-.053 3.536c-.02 1.237.707 2.383 1.775 2.807 3.622 1.434 12.58 4.048 25.937 1.773 1.041-.174 1.782-1.16 1.764-2.345l-.12-3.51-29.302-2.256z'
      />
      <path
        fill='url(#asoodehDashboardCoins_svg__i)'
        d='M-.408 23.595c0 1.65-6.56 2.53-14.652 1.965-8.091-.566-14.651-2.367-14.65-4.016s6.56-2.53 14.652-1.964 14.651 2.367 14.65 4.015'
      />
      <path
        stroke='url(#asoodehDashboardCoins_svg__j)'
        strokeMiterlimit={10}
        strokeWidth={0.24}
        d='M-.408 23.595c0 1.65-6.56 2.53-14.652 1.965-8.091-.566-14.651-2.367-14.65-4.016s6.56-2.53 14.652-1.964 14.651 2.367 14.65 4.015Z'
      />
      <g opacity={0.54}>
        <mask
          id='asoodehDashboardCoins_svg__k'
          width={30}
          height={12}
          x={-30}
          y={19}
          maskUnits='userSpaceOnUse'
          style={{
            maskType: 'luminance',
          }}
        >
          <path
            fill='#fff'
            d='M-15.059 19.579c-7.758-.546-14.108.242-14.619 1.762l-.032-.002-.053 3.536c-.02 1.237.707 2.383 1.775 2.806 3.621 1.435 12.58 4.049 25.936 1.774 1.042-.174 1.782-1.16 1.765-2.345l-.12-3.511c0-1.649-6.559-3.45-14.65-4.015z'
          />
        </mask>
      </g>
    </g>
    <g opacity={0.5}>
      <path
        fill='url(#asoodehDashboardCoins_svg__l)'
        d='m46 59.38.61-.9s.478-3.527-3.462-9.236c0 0-2.878-4.496-9.593-4.032-6.717.464-13.985 6.459-14.198 16.466 0 0 .225 4.874 4.502 9.393z'
      />
      <path
        fill='url(#asoodehDashboardCoins_svg__m)'
        d='M39.917 71.601c6.218-4.493 8.517-12.775 5.134-18.5-3.382-5.723-11.166-6.721-17.385-2.228-6.218 4.493-8.517 12.775-5.134 18.5 3.382 5.723 11.166 6.721 17.385 2.228'
      />
      <path
        stroke='url(#asoodehDashboardCoins_svg__n)'
        strokeMiterlimit={10}
        strokeWidth={0.57}
        d='M39.917 71.601c6.218-4.493 8.517-12.775 5.134-18.5-3.382-5.723-11.166-6.721-17.385-2.228-6.218 4.493-8.517 12.775-5.134 18.5 3.382 5.723 11.166 6.721 17.385 2.228Z'
      />
      <path
        fill='#C16F2A'
        d='M38.55 69.285c4.83-3.49 6.616-9.923 3.989-14.37-2.628-4.445-8.673-5.22-13.504-1.73s-6.616 9.923-3.989 14.369c2.628 4.446 8.674 5.22 13.504 1.73'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <mask
        id='asoodehDashboardCoins_svg__o'
        width={21}
        height={21}
        x={23}
        y={51}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill='#fff'
          d='M38.55 69.285c4.83-3.49 6.616-9.923 3.989-14.37-2.628-4.445-8.673-5.22-13.504-1.73s-6.616 9.923-3.989 14.369c2.628 4.446 8.674 5.22 13.504 1.73'
        />
      </mask>
      <g mask='url(#asoodehDashboardCoins_svg__o)'>
        <path
          fill='url(#asoodehDashboardCoins_svg__p)'
          d='M38.122 68.99c4.83-3.49 6.617-9.923 3.99-14.37-2.628-4.445-8.674-5.22-13.504-1.73s-6.617 9.923-3.99 14.369c2.628 4.446 8.674 5.22 13.504 1.73'
        />
      </g>
      <path
        fill='url(#asoodehDashboardCoins_svg__q)'
        d='M38.55 69.285c4.83-3.49 6.616-9.923 3.989-14.37-2.628-4.445-8.673-5.22-13.504-1.73s-6.616 9.923-3.989 14.369c2.628 4.446 8.674 5.22 13.504 1.73'
        opacity={0.49}
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <mask
        id='asoodehDashboardCoins_svg__r'
        width={28}
        height={30}
        x={19}
        y={45}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill='#fff'
          d='M39.918 71.603c4.44-3.208 6.882-8.351 6.683-13.111l.008-.012s.478-3.526-3.462-9.236c0 0-2.875-4.497-9.593-4.032-6.717.465-13.985 6.46-14.198 16.466 0 0 .196 4.208 3.657 8.43 3.596 5.067 10.964 5.79 16.905 1.495'
        />
      </mask>
      <g mask='url(#asoodehDashboardCoins_svg__r)'>
        <path
          fill='#fff'
          d='m44.27 70.986-11.872-48.54-2.974.701 11.87 48.541zM37.762 72.778l-14.846-47.84 2.973-.702zM36.126 29.631l14.848 47.84-2.973.701zM24.766 51.504l14.845 47.84-2.973.701z'
          opacity={0.2}
          style={{
            mixBlendMode: 'overlay',
          }}
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id='asoodehDashboardCoins_svg__a'
        x1={71.883}
        x2={127.275}
        y1={5.924}
        y2={-8.918}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E5AF16' />
        <stop offset={1} stopColor='#B47B19' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__b'
        x1={89.81}
        x2={103.284}
        y1={-33.645}
        y2={16.642}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F9D95D' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__c'
        x1={89.764}
        x2={103.33}
        y1={-33.815}
        y2={16.811}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFFFC0' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__e'
        x1={76.953}
        x2={118.011}
        y1={-2.522}
        y2={-13.524}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__f'
        x1={106.809}
        x2={92.635}
        y1={3.241}
        y2={-9.899}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__h'
        x1={-28.817}
        x2={-0.992}
        y1={28.863}
        y2={21.407}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E5AF16' />
        <stop offset={1} stopColor='#B47B19' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__i'
        x1={-28.494}
        x2={-1.624}
        y1={26.17}
        y2={18.97}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F9D95D' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__j'
        x1={-28.546}
        x2={-1.577}
        y1={26.183}
        y2={18.957}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFFFC0' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__l'
        x1={46.358}
        x2={19.109}
        y1={55.871}
        y2={60.402}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E5AF16' />
        <stop offset={1} stopColor='#B47B19' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__m'
        x1={35.918}
        x2={32.589}
        y1={73.928}
        y2={48.352}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F9D95D' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__n'
        x1={35.932}
        x2={32.58}
        y1={74.013}
        y2={48.263}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFFFC0' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__p'
        x1={43.532}
        x2={23.335}
        y1={59.578}
        y2={62.933}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' />
      </linearGradient>
      <linearGradient
        id='asoodehDashboardCoins_svg__q'
        x1={29.381}
        x2={35.7}
        y1={54.776}
        y2={62.077}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FEC13A' />
        <stop offset={1} stopColor='#F9CB5D' stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAsoodehDashboardCoins;
